import { userStore } from '@/entities/user';
import { TermAndConditionPage } from '@/pages/term-and-condition';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/terms-and-conditions')({
  beforeLoad: () => {
    const isTermAndConditionAccepted =
      userStore.state?.isTermsAndConditionsAccepted;
    console.log({ isTermAndConditionAccepted });

    if (isTermAndConditionAccepted) {
      throw redirect({ to: '/' });
    }
  },
  component: TermAndConditionPage,
});
